var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2889 7.04257L14.6938 6.1301L11.7455 0.440169C11.665 0.284382 11.5325 0.158269 11.3689 0.0816118C10.9585 -0.111267 10.4598 0.0494654 10.2546 0.440169L7.30634 6.1301L0.711168 7.04257C0.52934 7.0673 0.363097 7.1489 0.235817 7.27254C0.0819425 7.4231 -0.00284927 7.62566 7.31104e-05 7.8357C0.00299549 8.04575 0.0933929 8.24609 0.251402 8.39272L5.0231 12.8215L3.89576 19.0753C3.86932 19.2207 3.88623 19.3703 3.94457 19.5071C4.00291 19.6439 4.10035 19.7624 4.22583 19.8492C4.35131 19.9359 4.49981 19.9875 4.6545 19.998C4.80919 20.0085 4.96388 19.9775 5.10102 19.9086L11.0001 16.9561L16.8991 19.9086C17.0601 19.9902 17.2472 20.0174 17.4264 19.9877C17.8784 19.9135 18.1823 19.5055 18.1043 19.0753L16.977 12.8215L21.7487 8.39272C21.8786 8.27156 21.9643 8.1133 21.9903 7.9402C22.0604 7.50746 21.7435 7.10686 21.2889 7.04257Z",
    fill: "#FFB13C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.faddd46b6aa3a5423b3b857c3f31d245.svg";
export { ForwardRef as ReactComponent };